import { __awaiter, __generator } from "tslib";
import { applePaySessionApi } from '../../api/apple-pay-session';
import { createFrameApplePayCancelMessage, createFrameApplePayFailureMessage, createFrameApplePaySuccessMessage } from './frame-apple-pay-message';
export var beginApplePaySession = function (_a) {
    var apiHost = _a.apiHost, purchaseToken = _a.purchaseToken, merchantId = _a.merchantId, request = _a.request, onSendResponse = _a.onSendResponse;
    var session = new ApplePaySession(3, request);
    session.onvalidatemerchant = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var merchantSession, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, applePaySessionApi(apiHost, {
                            validationURL: event.validationURL,
                            purchaseToken: purchaseToken,
                            merchantId: merchantId
                        })];
                case 1:
                    merchantSession = _a.sent();
                    session.completeMerchantValidation(merchantSession);
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    onSendResponse(createFrameApplePayFailureMessage());
                    session.abort();
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    session.onpaymentauthorized = function (event) {
        onSendResponse(createFrameApplePaySuccessMessage(event.payment, merchantId));
        session.completePayment({
            status: ApplePaySession.STATUS_SUCCESS
        });
    };
    session.oncancel = function () {
        onSendResponse(createFrameApplePayCancelMessage());
    };
    session.begin();
};
